module.exports = __webpack_public_path__ + "static/media/icon.1ed92a96.png";